import {getFormattedFullLocation} from '@wix/wix-events-commons-statics'
import React from 'react'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {FullLocationProps} from './index'

export const FullLocation: React.FC<FullLocationProps> = ({event}) => (
  <p data-hook={DH.eventDetailsFullLocation}>{getFormattedFullLocation(event)}</p>
)
